import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import styled from '@xstyled/styled-components';
import { Checkbox, Tooltip } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { getColor, getSize, MathEnabledTextComponent, styleVariables } from '@lib/common';
import { getAnswerStatusColorTooltip } from '@module/assignment-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledAnswerCheckbox = styled(Checkbox).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['$isCorrectAnswer', '$isSelected', '$isMissedCorrect', '$isWrongSelected', '$isManuallyAwarded'].includes(prop);
  }
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  flex: 1;\n  cursor: default;\n\n  align-self: center;\n  display: flex;\n  align-items: center;\n  justify-content: start;\n\n  padding: 12px;\n  border-radius: ", ";\n\n  border-width: 1px;\n  border-style: solid;\n  border-color: ", ";\n\n  background-color: ", ";\n\n  .ant-checkbox {\n    top: 0 !important;\n  }\n\n  span.ant-checkbox + * {\n    flex: 1;\n    top: 0 !important;\n    height: auto;\n    padding-right: 0;\n    display: flex;\n    align-items: center;\n    flex-wrap: nowrap;\n  }\n\n  .ant-checkbox-inner {\n    width: 18px;\n    height: 18px;\n    background-color: ", ";\n    border-color: ", " !important;\n    border-style: solid;\n    border-width: 1px;\n  }\n\n  .ant-checkbox-checked .ant-checkbox-inner {\n    background-color: ", ";\n    border-color: ", " !important;\n  }\n\n  .ant-checkbox-checked .ant-checkbox-inner::after {\n    border-color: ", ";\n  }\n"])), getSize('padding8'), function (_ref) {
  var $isMissedCorrect = _ref.$isMissedCorrect,
      $isSelected = _ref.$isSelected,
      $isCorrectAnswer = _ref.$isCorrectAnswer,
      $isWrongSelected = _ref.$isWrongSelected,
      $isManuallyAwarded = _ref.$isManuallyAwarded;
  if ($isMissedCorrect) return getColor('successActive');
  if ($isSelected && $isCorrectAnswer) return getColor('successActive');
  if ($isWrongSelected && $isManuallyAwarded) return styleVariables.colors.gold1;
  if ($isWrongSelected) return getColor('errorActive');
  return '#cbd5e1';
}, function (_ref2) {
  var $isSelected = _ref2.$isSelected,
      $isCorrectAnswer = _ref2.$isCorrectAnswer,
      $isWrongSelected = _ref2.$isWrongSelected,
      $isManuallyAwarded = _ref2.$isManuallyAwarded;
  if ($isSelected && $isCorrectAnswer) return getColor('successBgActive');
  if ($isWrongSelected && $isManuallyAwarded) return '#FFF7E6';
  if ($isWrongSelected) return getColor('errorBgActive');
  return 'transparent';
}, function (_ref3) {
  var $isSelected = _ref3.$isSelected,
      $isCorrectAnswer = _ref3.$isCorrectAnswer,
      $isWrongSelected = _ref3.$isWrongSelected,
      $isManuallyAwarded = _ref3.$isManuallyAwarded;
  if ($isSelected && $isCorrectAnswer) return getColor('successActive');
  if ($isWrongSelected && $isManuallyAwarded) return styleVariables.colors.gold1;
  if ($isWrongSelected) return getColor('errorActive');
  return getColor('fillBgWhite');
}, function (_ref4) {
  var $isSelected = _ref4.$isSelected,
      $isCorrectAnswer = _ref4.$isCorrectAnswer,
      $isMissedCorrect = _ref4.$isMissedCorrect,
      $isWrongSelected = _ref4.$isWrongSelected,
      $isManuallyAwarded = _ref4.$isManuallyAwarded;
  if ($isSelected && $isCorrectAnswer) return getColor('successActive');
  if ($isWrongSelected && $isManuallyAwarded) return styleVariables.colors.gold1;
  if ($isWrongSelected) return getColor('errorActive');
  if ($isMissedCorrect) return getColor('successActive');
  return '#cbd5e1';
}, function (_ref5) {
  var $isCorrectAnswer = _ref5.$isCorrectAnswer,
      $isSelected = _ref5.$isSelected,
      $isWrongSelected = _ref5.$isWrongSelected,
      $isManuallyAwarded = _ref5.$isManuallyAwarded;
  if ($isSelected && $isCorrectAnswer) return getColor('successActive');
  if ($isWrongSelected && $isManuallyAwarded) return styleVariables.colors.gold1;
  if ($isWrongSelected) return getColor('errorActive');
  return getColor('fillBgWhite');
}, function (_ref6) {
  var $isCorrectAnswer = _ref6.$isCorrectAnswer,
      $isSelected = _ref6.$isSelected,
      $isWrongSelected = _ref6.$isWrongSelected,
      $isManuallyAwarded = _ref6.$isManuallyAwarded;
  if ($isSelected && $isCorrectAnswer) return getColor('successActive');
  if ($isWrongSelected && $isManuallyAwarded) return styleVariables.colors.gold1;
  if ($isWrongSelected) return getColor('errorActive');
  return getColor('fillIntActive');
}, function (_ref7) {
  var $isCorrectAnswer = _ref7.$isCorrectAnswer,
      $isSelected = _ref7.$isSelected,
      $isWrongSelected = _ref7.$isWrongSelected,
      $isManuallyAwarded = _ref7.$isManuallyAwarded;
  if ($isSelected && $isCorrectAnswer || $isWrongSelected || $isManuallyAwarded) return '#fff';
  return getColor('fillIntActive');
});
var StyledAnswerPrefix = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 700;\n  color: #334155;\n  margin-right: ", ";\n  white-space: nowrap;\n"])), getSize('typo14'), getSize('padding8'));
var StyledAnswerText = styled(MathEnabledTextComponent)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 700;\n  color: #334155;\n  line-height: ", ";\n  flex: 1;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  min-width: 0;\n  display: inline;\n  text-decoration: ", ";\n\n  p {\n    margin: 0;\n    display: inline;\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n  }\n\n  img {\n    max-width: 100%;\n    height: auto;\n    display: block;\n  }\n\n  table {\n    max-width: 100%;\n    table-layout: auto;\n    word-wrap: break-word;\n  }\n\n  .math-container {\n    display: inline-block;\n    vertical-align: middle;\n    max-width: 100%;\n  }\n\n  * {\n    max-width: 100%;\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n"])), getSize('typo14'), getSize('padding20'), function (_ref8) {
  var $isWrongSelected = _ref8.$isWrongSelected;
  return $isWrongSelected ? 'line-through' : 'none';
});
var StyledAnswerTag = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  gap: ", ";\n  font-size: ", ";\n  font-weight: 600;\n  white-space: nowrap;\n  padding: 2px ", ";\n  border-radius: ", ";\n  margin-left: ", ";\n  flex-shrink: 0;\n\n  color: ", ";\n  background-color: ", ";\n  border-width: 1px;\n  border-style: solid;\n  border-color: ", ";\n"])), getSize('padding4'), getSize('typo12'), getSize('padding8'), getSize('radiusS'), getSize('padding12'), function (_ref9) {
  var $isCorrect = _ref9.$isCorrect,
      $isWrong = _ref9.$isWrong,
      $isManuallyAwarded = _ref9.$isManuallyAwarded;
  if ($isManuallyAwarded) return styleVariables.colors.gold1;
  if ($isWrong) return getColor('errorActive');
  return getColor('successActive');
}, function (_ref10) {
  var $isCorrect = _ref10.$isCorrect,
      $isWrong = _ref10.$isWrong,
      $isMissed = _ref10.$isMissed,
      $isManuallyAwarded = _ref10.$isManuallyAwarded;
  if ($isManuallyAwarded) return '#FFF7E6';
  if ($isCorrect) return getColor('successBgActive');
  if ($isWrong) return getColor('errorBgActive');
  return 'transparent';
}, function (_ref11) {
  var $isWrong = _ref11.$isWrong,
      $isManuallyAwarded = _ref11.$isManuallyAwarded;
  if ($isManuallyAwarded) return styleVariables.colors.gold1;
  if ($isWrong) return getColor('errorActive');
  return getColor('successActive');
});
var StyledAnswerWrapper = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n"])));
export var AnswerItemComponent = function AnswerItemComponent(_ref12) {
  var key = _ref12.key,
      answerId = _ref12.answerId,
      description = _ref12.description,
      isCorrect = _ref12.isCorrect,
      isSelected = _ref12.isSelected,
      index = _ref12.index,
      _ref12$isResponderVie = _ref12.isResponderView,
      isResponderView = _ref12$isResponderVie === void 0 ? false : _ref12$isResponderVie,
      _ref12$isManuallyAwar = _ref12.isManuallyAwarded,
      isManuallyAwarded = _ref12$isManuallyAwar === void 0 ? false : _ref12$isManuallyAwar,
      colorStatusCorrect = _ref12.colorStatusCorrect,
      colorStatusIncorrect = _ref12.colorStatusIncorrect,
      colorStatusCustomGrade = _ref12.colorStatusCustomGrade;
  var isWrongSelected = isSelected && !isCorrect;
  var isMissedCorrect = !isSelected && isCorrect;
  var isCorrectSelected = isSelected && isCorrect;
  var isManuallyAwardedSelected = isWrongSelected && isManuallyAwarded;
  var answerLabel = isResponderView ? 'YOUR ANSWER' : 'STUDENT ANSWER';

  var getTooltipTitle = function getTooltipTitle() {
    if (isCorrectSelected || isMissedCorrect) {
      return getAnswerStatusColorTooltip('correct', {
        correct: colorStatusCorrect
      });
    }

    if (isManuallyAwardedSelected) {
      return getAnswerStatusColorTooltip('manuallyAwarded', {
        customGrade: colorStatusCustomGrade
      });
    }

    if (isWrongSelected) {
      return getAnswerStatusColorTooltip('incorrect', {
        incorrect: colorStatusIncorrect
      });
    }

    return undefined;
  };

  var renderTag = function renderTag() {
    if (isCorrectSelected) {
      return /*#__PURE__*/_jsxs(StyledAnswerTag, {
        $isCorrect: true,
        children: [/*#__PURE__*/_jsx(CheckOutlined, {}), answerLabel]
      });
    }

    if (isManuallyAwardedSelected) {
      return /*#__PURE__*/_jsxs(StyledAnswerTag, {
        $isManuallyAwarded: true,
        children: [/*#__PURE__*/_jsx(CheckOutlined, {}), answerLabel]
      });
    }

    if (isWrongSelected) {
      return /*#__PURE__*/_jsxs(StyledAnswerTag, {
        $isWrong: true,
        children: [/*#__PURE__*/_jsx(CloseOutlined, {}), answerLabel]
      });
    }

    if (isMissedCorrect) {
      return /*#__PURE__*/_jsxs(StyledAnswerTag, {
        $isMissed: true,
        children: [/*#__PURE__*/_jsx(CheckOutlined, {}), "CORRECT \xB7 MISSED"]
      });
    }

    return null;
  };

  var answerContent = /*#__PURE__*/_jsx(StyledAnswerWrapper, {
    children: /*#__PURE__*/_jsxs(StyledAnswerCheckbox, {
      value: answerId,
      checked: isSelected,
      $isSelected: isSelected,
      $isCorrectAnswer: isCorrect,
      $isMissedCorrect: isMissedCorrect,
      $isWrongSelected: isWrongSelected,
      $isManuallyAwarded: isManuallyAwardedSelected,
      disabled: true,
      children: [/*#__PURE__*/_jsxs(StyledAnswerPrefix, {
        children: [String.fromCharCode(65 + index), "."]
      }), /*#__PURE__*/_jsx(StyledAnswerText, {
        $isWrongSelected: isWrongSelected && !isManuallyAwardedSelected,
        value: description
      }), renderTag()]
    }, answerId)
  });

  var tooltipTitle = getTooltipTitle();
  return tooltipTitle ? /*#__PURE__*/_jsx(Tooltip, {
    title: tooltipTitle,
    children: answerContent
  }) : answerContent;
};